import styled, { css } from "styled-components";
import { FloatingLabel } from "react-bootstrap";

export const CustomFloatingLabel = styled(FloatingLabel)`
  > .form-control-plaintext ~ label,
  > .form-control:focus ~ label,
  > .form-control:not(:placeholder-shown) ~ label,
  > .form-select ~ label {
    font-size: 0.7rem;
    background-color: transparent;
    color: var(--heeros-blue-600-brand);

    &:after {
      background-color: transparent;
    }
  }

  label {
    z-index: 0;

    ${(props) =>
      props.active === "true" &&
      css`
        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
        font-size: 0.7rem;
        background-color: transparent;
        color: var(--heeros-blue-600-brand);

        .FormSelectWrapper &,
        .DatePicker & {
          transform: scale(0.85) translateY(-1.1rem) translateX(0.15rem);
        }
      `};
  }
`;
